module.exports = __webpack_public_path__ + "assets/CircleInRhombusDetailed.3eb104afd025e2a327301c14ee11f4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleInRhombusDetailed.png
// module id = 487
// module chunks = 0